import { RoleNameField } from 'pages/Roles/components/RoleNameField';
import { RolesStatusesChipsField } from 'pages/Roles/components/RolesStatusesChipsField';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { TextField } from 'shared/react-admin/Fields';

export const RolesShowTable: React.FC = () => (
  <CardTable tableBodyProps={{ sx: { '& td': { width: '138px' } } }}>
    <TableRowWrapper label="ID">
      <TextField source="originId" />
    </TableRowWrapper>
    <TableRowWrapper label="Название">
      <RoleNameField />
    </TableRowWrapper>
    <TableRowWrapper label="Алиас">
      <TextField source="alias" />
    </TableRowWrapper>
    <TableRowWrapper label="Статусы заказа">
      <RolesStatusesChipsField label="Статусы заказа" />
    </TableRowWrapper>
  </CardTable>
);
